import { Heading } from '@chakra-ui/react';
import React from 'react';

import { Breadcrumbs } from 'packages/common-frontend/components/Breadcrumbs';
import { TimelineStepper } from 'packages/transactions/ui/TimelineStepper';

export type CreateInvoiceStepIndex = 0 | 1 | 2 | 3;

const timelineDisplaySteps = [
  {
    id: '1',
    icon: 'info',
    title: 'Details',
  },
  {
    id: '2',
    icon: 'money-check-dollar',
    title: 'Payment',
  },
  {
    id: '3',
    icon: 'list',
    title: 'Line Items',
  },
  {
    id: '4',
    icon: 'check',
    title: 'Review',
  },
];

export const CreateInvoiceHeaderWithTimelineStepper = ({
  completedStepIndex,
}: {
  completedStepIndex: number;
}) => {
  return (
    <>
      <Breadcrumbs breadcrumbs={[{ label: 'Invoices', path: '/invoices' }]} />
      <Heading mt="24px" mb="64px">
        Create Invoice
      </Heading>
      <TimelineStepper
        steps={timelineDisplaySteps}
        completedStepIndex={completedStepIndex}
      />
    </>
  );
};
